import { Link } from 'react-router-dom';
import type { ItemReservationOverlay } from '@/modules/reservations/services';
import { RESERVATION_STATUS_LABELS } from '@/modules/reservations/types';
import { modulePaths } from '@/routes/paths';

type ItemReservationHintProps = {
  overlay: ItemReservationOverlay;
};

/** Indica disponibilidad temporal por reserva (no reemplaza el estado operativo del ítem). */
export function ItemReservationHint({ overlay }: ItemReservationHintProps) {
  return (
    <Link
      to={`${modulePaths.reservations}/${overlay.reservationId}`}
      className="item-reservation-hint"
      title="Disponibilidad temporal por reserva"
    >
      Reserva: {overlay.title} ({RESERVATION_STATUS_LABELS[overlay.status]}) ·{' '}
      {overlay.startDate} → {overlay.endDate}
    </Link>
  );
}
